import { Button, Card, CardContent, Typography } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { useIntercom } from "react-use-intercom";
import no_plan from "../../assets/images/no_plan.svg";
import plan_expired from "../../assets/images/plan_expired.svg";
import { isFreeStack } from "@/helpers/tenant";

interface PlanEmptyScreenProps {
  errorType: "no_plan" | "expired_plan";
  endDate?: string | null;
  onPurchasePlan?: () => void;
}

const PlanEmptyScreen = ({ errorType, endDate, onPurchasePlan }: PlanEmptyScreenProps) => {
  const { show } = useIntercom();

  const isExpiredPlan = errorType === "expired_plan";
  const imageSrc = isExpiredPlan ? plan_expired : no_plan;
  const title = isExpiredPlan ? "Your plan has expired!" : "No active plans!";

  const description = isExpiredPlan ? (
    <>
      Your plan expired on <span className="al-text-blue-600 al-font-semibold">{endDate}</span>.
      Please purchase a new plan or contact us to proceed!
    </>
  ) : (
    "Looks like you haven't added any plan to this workspace!"
  );

  return (
    <div className="al-min-h-[400px] al-w-full">
      <Stack direction="column" align="center" justify="center" className="al-h-full">
        <Card className="al-w-full ">
          <CardContent>
            <Stack className="!al-p-8" align="center" justify="center">
              <Stack direction="column" align="center" gap="lg" className="al-w-full al-max-w-md">
                <img
                  src={imageSrc}
                  alt={isExpiredPlan ? "Plan expired" : "No plan"}
                  className="al-w-32 al-h-32 al-object-contain"
                />

                <Typography
                  variant="body"
                  className="al-text-2xl al-font-semibold al-text-gray-900"
                >
                  {title}
                </Typography>

                <Typography
                  variant="body" size="xs"
                  className="al-text-gray-600 al-leading-relaxed al-whitespace-nowrap"
                >
                  {description}
                </Typography>

                <Stack direction="row" align="center" justify="center" className="al-w-full">
                  <Button variant="outline" onClick={show}>
                    Contact us
                  </Button>
                  {isFreeStack() && <Button onClick={onPurchasePlan}>Purchase plan</Button>}
                </Stack>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      </Stack>
    </div>
  );
};

export default PlanEmptyScreen;
